import { render, staticRenderFns } from "./ProductD.vue?vue&type=template&id=204939c0&scoped=true&lang=pug"
import script from "./ProductD.vue?vue&type=script&lang=js"
export * from "./ProductD.vue?vue&type=script&lang=js"
import style0 from "./ProductD.vue?vue&type=style&index=0&id=204939c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204939c0",
  null
  
)

export default component.exports